<div #dropdown class="select-dropdown">
  <ng-content></ng-content>
</div>
